import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import {
  PlumbingItemProperties,
  PlumbingProductId,
  PlumbingState,
} from './plumbing.types';

import { PlumbingProduct } from '~/core/models';

const initialState: PlumbingState = {
  selectedPlumbing: {},
};

const plumbingSlice = createSlice({
  name: 'plumbing',
  initialState,
  reducers: {
    addSelectedPlumbing: (state, action: PayloadAction<PlumbingProduct>) => {
      state.selectedPlumbing[action.payload.productId] = {
        quantity: 1,
        isSelected: true,
        isManuallyChanged: false,
      };
    },
    removeSelectedPlumbing: (state, action: PayloadAction<PlumbingProduct>) => {
      delete state.selectedPlumbing[action.payload.productId];
    },
    updateSelectedPlumbing: (
      state,
      action: PayloadAction<Record<PlumbingProductId, PlumbingItemProperties>>
    ) => {
      state.selectedPlumbing = action.payload;
    },
    setPlumbingQuantity: (
      state,
      action: PayloadAction<{ productId: PlumbingProductId; quantity: number }>
    ) => {
      const item = state.selectedPlumbing[action.payload.productId];

      if (item) {
        item.quantity = action.payload.quantity;
        item.isSelected = action.payload.quantity > 0;
        item.isManuallyChanged = true;
      }
    },
    resetSelectedPlumbing: (state) => {
      state.selectedPlumbing = initialState.selectedPlumbing;
    },
  },
});

export const {
  addSelectedPlumbing,
  removeSelectedPlumbing,
  updateSelectedPlumbing,
  setPlumbingQuantity,
  resetSelectedPlumbing,
} = plumbingSlice.actions;

export const selectSelectedPlumbing = (state: {
  plumbing: PlumbingState;
}): Record<PlumbingProductId, PlumbingItemProperties> =>
  state.plumbing.selectedPlumbing;

export const selectPlumbingQuantity = (
  state: { plumbing: PlumbingState },
  productId: PlumbingProductId
): number => state.plumbing.selectedPlumbing[productId]?.quantity ?? 0;

export const selectIsPlumbingSelected = (
  state: { plumbing: PlumbingState },
  productId: PlumbingProductId
): boolean => state.plumbing.selectedPlumbing[productId]?.isSelected ?? false;

export default plumbingSlice.reducer;
